module.exports = __webpack_public_path__ + "static/media/suspend-icon.8dad44a3.svg";